import createAuth0Client from "@auth0/auth0-spa-js";
import config from "../../assets/config";

const { domain, client_id } = config;
let client;

export async function getClient() {
  if (client) return client;
  client = await createAuth0Client({
    domain,
    client_id,
  });
  return client;
}